import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "../../components/ui/avatar";
import { Button } from "../../components/ui/button";
import type { UserType } from "../../types";

function Profile(props: { user: UserType | null; onUpdate: () => void }) {
  const { user, onUpdate } = props;

  const handleConfirm = () => {
    const confirmUser = async () => {
      try {
        const response = await fetch(
          "/api/users/" +
            window.Telegram.WebApp.initDataUnsafe.user.id +
            "/confirm",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        
        if (!response.ok) {
          console.error("Failed to confirm user");
        }
        
        onUpdate();
      } catch (error) {
        console.error("Error confirming user:", error);
      }
    };
    confirmUser();
  };

  if (!user) {
    return;
  }

  return (
    <>
      <Card className="border-none bg-white text-black shadow-lg">
        <CardHeader className="pb-2 text-center">
          <div className="flex justify-center mb-4">
            <Avatar className="h-24 w-24">
              <AvatarImage src={`/api/users/${user.telegram_id}/avatar`} />
              <AvatarFallback className="text-xl">
                {user.last_name.slice(0, 2)}
              </AvatarFallback>
            </Avatar>
          </div>
          <CardTitle className="text-2xl font-bold text-center">
            {`${user.first_name} ${user.last_name}`}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 gap-3">
            <ProfileItem label="Город" value={user.city} />
            <ProfileItem label="Группа" value={user.study_group} />
            <ProfileItem label="Работа" value={user.employment_summary} />
            <ProfileItem
              label="Услуги/экспертиза"
              value={user.expertise_offered}
            />
            <ProfileItem label="Индустрии" value={user.industries} />
            <ProfileItem label="Функциональные роли" value={user.positions} />
            <ProfileItem label="Интересный факт" value={user.random_fact} />
          </div>
        </CardContent>
      </Card>

      <Button
        variant="ghost"
        className="mt-4 bg-[#D33F44] w-full hover:bg-[#B8353A] text-white border-none shadow-none"
        onClick={handleConfirm}
      >
        Подтвердить
      </Button>
    </>
  );
}

// Component for profile items
function ProfileItem({ label, value }: { label: string; value: string }) {
  return (
    <div className="space-y-1">
      <p className="text-sm font-medium text-gray-500">{label}</p>
      <p className="text-sm">{value}</p>
    </div>
  );
}

export { Profile };
